var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilyMedicine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M24.048,6.085c-1.192,0.158-2.345,0.787-2.345,0.787s-1.851,2.95-2.168,5.84 c0.257,0.623,0.652,1.173,1.23,1.601c1.05,0.779,2.19,1.091,3.283,1.1V6.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M23.987,6.085c1.192,0.158,2.345,0.787,2.345,0.787s1.851,2.95,2.168,5.84 c-0.257,0.623-0.652,1.173-1.23,1.601c-1.05,0.779-2.19,1.091-3.283,1.1V6.085z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M29.878,26.484 c0.201-1.926,0.227-3.904,0.208-4.918c-0.038-0.556-0.045-1.137-0.037-1.724c-0.525,0.369-1.257,0.455-1.871,0.233l-0.47,1.236 l0.503,5.173H29.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M27.729,22.462 c0.678,0.16,2.772-0.794,2.85-1.212c-0.609-2.592-1.159-5.16-2.414-6.1c-0.504,0.971-1.271,1.706-0.913,3.798L27.729,22.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20.242,26.484l0.657-4.898l-0.424-1.252 c-0.621,0.2-1.349,0.087-1.861-0.301c-0.014,0.587-0.041,1.168-0.1,1.722c-0.054,0.979-0.099,2.86,0.016,4.73L20.242,26.484 L20.242,26.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20.762,22.43 c-0.677,0.16-2.772-0.794-2.85-1.212c0.609-2.592,1.159-5.16,2.414-6.1c0.504,0.971,1.271,1.706,0.913,3.798L20.762,22.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M20.458,22.217l-0.384,4.267h8.323 l-0.41-4.245c1.326-2.095,0.097-4.135,0.097-4.135c-0.115-1.277,0.098-2.946,0.098-2.946c-1.021-0.704-2.485-0.897-3.482-0.94 c-0.105-0.005-0.274-0.011-0.489-0.011s-0.384,0.006-0.489,0.011c-0.997,0.043-2.461,0.236-3.482,0.94c0,0,0.213,1.669,0.098,2.946 C20.337,18.104,19.132,20.122,20.458,22.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M24.087,15.453h-0.046 c-0.575,0-1.042-0.123-1.042-0.698v-1.983c0-0.575,0.466-1.042,1.042-1.042h0.046c0.575,0,1.042,0.466,1.042,1.042v1.983 C25.129,15.33,24.663,15.453,24.087,15.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161B43"
    },
    d: "M25.103,13.516c-0.385,0.273-0.786,0.306-1.034,0.306c-0.247,0-0.66-0.025-1.057-0.29v0.218 c0.397,0.264,0.809,0.41,1.057,0.41c0.247,0,0.649-0.153,1.034-0.426V13.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M26.752,9.678 c-0.087-0.019-0.176-0.004-0.261,0.038c0.008-0.146,0.013-0.252,0.015-0.295c0.001-0.016,0.001-0.032,0-0.048 c-0.012-0.268-0.178-2.483-2.541-2.458c-2.363,0.025-2.482,2.244-2.488,2.512c0,0.016,0,0.032,0.001,0.048 c0.003,0.045,0.011,0.157,0.023,0.312c-0.101-0.051-0.205-0.068-0.304-0.039c-0.289,0.086-0.413,0.528-0.277,0.987 c0.133,0.446,0.463,0.744,0.747,0.681c0.062,0.46,0.168,0.85,0.222,1.02c0.378,1.186,1.6,1.521,2.165,1.521 s1.797-0.482,2.103-1.566c0.049-0.172,0.148-0.564,0.2-1.025c0.006,0.002,0.011,0.004,0.017,0.005 c0.295,0.066,0.618-0.26,0.722-0.728C27.201,10.176,27.046,9.744,26.752,9.678z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M24.038,5.819c3.56,0.021,2.741,3.94,2.393,4.034c0,0-0.689-1.983-1.537-1.958 c-0.777,2.295-2.865,0.961-3.42,1.897C21.052,9.57,20.58,5.799,24.038,5.819z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M24.239,10.282l0.431,1.405 c0,0,0.039,0.321-0.253,0.341h-0.462"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M23.512,12.835c0,0,0.671,0.272,1.09-0.039"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M2.852,24.695 c0.009,0.442,0.034,1.068,0.081,1.79h2.16l0.124-2.137L4.701,23.13c-0.605,0.246-1.339,0.188-1.878-0.16 C2.853,23.556,2.869,24.138,2.852,24.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.457,26.484 c0.037-0.71,0.054-1.326,0.057-1.762c-0.024-0.557-0.015-1.138,0.008-1.725c-0.535,0.356-1.268,0.422-1.876,0.184l-0.502,1.223 l0.147,2.079L15.457,26.484L15.457,26.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M5.021,26.484h8.381l-0.044-0.95h2.931 c-0.552-8.634-1.757-9.607-1.757-9.607c-1.389-1.077-4.418-1.484-5.27-1.58v-0.011c-0.015,0.002-0.033,0.004-0.051,0.006 c-0.018-0.002-0.036-0.004-0.051-0.006v0.011c-0.853,0.096-3.881,0.503-5.27,1.58c0,0-1.204,0.973-1.757,9.607h2.931L5.021,26.484z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M7.91,12.648 c0.172,0.036,0.347,0.056,0.523,0.052c0.75-0.014,1.45-0.121,2.133-0.348c0.068,1.02,0.196,2.179,0.432,2.652 c0.462,0.926-2.113,0.869-2.113,0.869S6.67,15.81,7.269,14.934C7.812,14.143,7.888,12.924,7.91,12.648z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161B43"
    },
    d: "M9.941,13.549c-0.436,0.162-0.897,0.153-1.335,0.011c-0.302-0.098-0.529-0.303-0.738-0.453 c0.113-0.579,0.045-0.504,0.045-0.504l2.576-2.072c0,0,0,1.295,0.15,2.62C10.415,13.345,10.426,13.369,9.941,13.549z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CAA2",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M6.124,10.237 c-0.006-0.489,0.14-0.888,0.448-0.892C6.626,9.344,6.68,9.356,6.735,9.378C6.724,9.241,6.716,9.143,6.713,9.101 C6.712,9.085,6.712,9.069,6.712,9.052c0-0.003,0-0.008,0-0.012l0,0c0-0.009,0.001-0.019,0.001-0.03c0-0.004,0-0.008,0.001-0.013 c0-0.009,0.001-0.019,0.002-0.029c0-0.007,0.001-0.016,0.002-0.024C6.719,8.935,6.719,8.926,6.72,8.916 c0-0.01,0.001-0.021,0.002-0.033c0.001-0.009,0.002-0.018,0.003-0.028C6.726,8.841,6.728,8.827,6.73,8.812 c0-0.008,0.001-0.017,0.002-0.026c0.002-0.017,0.004-0.034,0.007-0.052C6.74,8.725,6.741,8.717,6.742,8.708 c0.003-0.02,0.006-0.04,0.009-0.06C6.753,8.64,6.754,8.632,6.756,8.624C6.76,8.602,6.764,8.579,6.768,8.556 C6.77,8.548,6.771,8.541,6.772,8.533c0.005-0.024,0.01-0.049,0.016-0.073C6.79,8.452,6.791,8.445,6.793,8.437 c0.006-0.027,0.012-0.053,0.019-0.08C6.814,8.35,6.816,8.343,6.818,8.335C6.825,8.308,6.833,8.28,6.841,8.252 C6.843,8.245,6.845,8.237,6.847,8.23c0.008-0.028,0.018-0.057,0.027-0.086c0.003-0.007,0.005-0.015,0.007-0.023 c0.01-0.029,0.021-0.059,0.032-0.088c0.003-0.007,0.005-0.015,0.008-0.022c0.011-0.03,0.024-0.06,0.037-0.09 c0.003-0.008,0.006-0.015,0.009-0.022c0.013-0.03,0.027-0.06,0.041-0.091C7.013,7.8,7.016,7.792,7.02,7.785 c0.015-0.03,0.03-0.06,0.047-0.09c0.004-0.008,0.008-0.016,0.012-0.023c0.016-0.03,0.034-0.059,0.052-0.089 C7.135,7.575,7.14,7.567,7.145,7.559C7.163,7.53,7.182,7.501,7.202,7.472c0.006-0.008,0.011-0.016,0.016-0.024 C7.238,7.42,7.259,7.392,7.28,7.364c0.006-0.008,0.012-0.017,0.019-0.025c0.022-0.027,0.045-0.054,0.068-0.081 C7.374,7.25,7.381,7.241,7.389,7.233c0.023-0.026,0.048-0.051,0.073-0.076C7.47,7.148,7.478,7.139,7.487,7.13 c0.025-0.025,0.052-0.048,0.078-0.072c0.01-0.009,0.019-0.017,0.029-0.026C7.621,7.01,7.649,6.988,7.678,6.966 C7.689,6.958,7.699,6.949,7.711,6.94C7.739,6.92,7.77,6.9,7.8,6.88c0.012-0.008,0.024-0.017,0.037-0.025 C7.868,6.836,7.9,6.818,7.932,6.8C7.946,6.792,7.96,6.784,7.974,6.776c0.032-0.017,0.066-0.033,0.1-0.049 C8.09,6.72,8.105,6.712,8.121,6.705c0.034-0.015,0.07-0.029,0.106-0.042c0.017-0.007,0.034-0.014,0.052-0.021 c0.035-0.013,0.073-0.024,0.11-0.035c0.02-0.006,0.039-0.013,0.06-0.019C8.486,6.577,8.526,6.569,8.565,6.56 c0.022-0.005,0.042-0.011,0.064-0.015C8.67,6.536,8.712,6.53,8.755,6.523C8.778,6.519,8.8,6.515,8.823,6.512 c0.045-0.006,0.092-0.01,0.139-0.015C8.984,6.495,9.005,6.491,9.028,6.49c0.071-0.006,0.144-0.009,0.219-0.01 C9.319,6.479,9.39,6.481,9.458,6.483C9.48,6.485,9.502,6.487,9.524,6.488c0.045,0.003,0.09,0.006,0.134,0.011 c0.025,0.003,0.049,0.006,0.074,0.01c0.039,0.005,0.077,0.01,0.115,0.017C9.872,6.53,9.896,6.535,9.92,6.54 c0.035,0.007,0.07,0.014,0.104,0.022c0.024,0.006,0.047,0.012,0.07,0.018c0.033,0.009,0.065,0.018,0.097,0.028 c0.022,0.007,0.044,0.014,0.065,0.022c0.031,0.011,0.062,0.022,0.092,0.034c0.02,0.008,0.04,0.016,0.06,0.024 c0.03,0.013,0.059,0.026,0.088,0.04c0.018,0.009,0.036,0.017,0.054,0.026c0.03,0.015,0.058,0.031,0.086,0.047 c0.015,0.009,0.031,0.017,0.046,0.026c0.03,0.018,0.059,0.038,0.088,0.057c0.011,0.008,0.023,0.015,0.034,0.023 c0.035,0.025,0.069,0.05,0.102,0.077c0.004,0.003,0.008,0.006,0.012,0.009c0.075,0.06,0.143,0.124,0.206,0.191 c0.006,0.006,0.011,0.013,0.017,0.019c0.025,0.027,0.049,0.053,0.072,0.081c0.008,0.009,0.015,0.019,0.023,0.028 c0.02,0.025,0.04,0.05,0.059,0.075c0.008,0.011,0.016,0.021,0.023,0.032c0.018,0.024,0.035,0.049,0.051,0.074 c0.007,0.011,0.015,0.023,0.022,0.034c0.016,0.025,0.031,0.049,0.046,0.074c0.007,0.011,0.013,0.023,0.02,0.034 c0.014,0.025,0.028,0.05,0.041,0.075c0.006,0.011,0.012,0.023,0.018,0.034c0.013,0.026,0.026,0.051,0.038,0.077 c0.005,0.01,0.01,0.021,0.015,0.031c0.012,0.027,0.024,0.054,0.036,0.081c0.004,0.009,0.007,0.017,0.011,0.026 c0.012,0.03,0.024,0.06,0.035,0.09c0.002,0.005,0.004,0.011,0.006,0.016c0.026,0.072,0.049,0.142,0.068,0.209 c0,0.002,0.001,0.003,0.001,0.005c0.009,0.031,0.017,0.062,0.025,0.092c0.002,0.009,0.004,0.017,0.006,0.026 c0.005,0.022,0.011,0.044,0.016,0.066c0.003,0.012,0.005,0.023,0.007,0.034c0.004,0.018,0.008,0.036,0.011,0.053 c0.002,0.012,0.005,0.024,0.007,0.036c0.003,0.015,0.006,0.03,0.008,0.045c0.002,0.013,0.004,0.025,0.006,0.037 s0.004,0.025,0.006,0.036c0.002,0.013,0.004,0.026,0.006,0.039c0.001,0.009,0.002,0.018,0.004,0.028 c0.002,0.013,0.003,0.027,0.005,0.039c0.001,0.006,0.001,0.012,0.002,0.018c0.002,0.014,0.003,0.028,0.004,0.041V8.87l0,0 c0.005,0.05,0.007,0.089,0.008,0.112c0.001,0.017,0.001,0.033,0,0.049c-0.002,0.042-0.007,0.14-0.014,0.277 c0.053-0.023,0.108-0.036,0.161-0.037c0.308-0.004,0.465,0.39,0.472,0.88c0.006,0.463-0.458,0.849-0.768,0.892 c-0.052,0.461-0.131,0.856-0.199,1.022c-0.299,0.729-1.408,1.308-2.143,1.318c-0.736,0.01-1.626-0.371-2.216-1.26 c-0.099-0.149-0.162-0.557-0.226-1.016C6.604,11.074,6.13,10.7,6.124,10.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M7.357,8.456c0,0-0.241,0.928-0.209,2.123l-0.46-1.173c0,0-0.105-0.569,0.032-0.683l0.336-0.408 L7.21,8.293l0.093,0.03L7.357,8.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M11.239,8.29c0,0,0.217,1.076,0.185,2.242l0.51-1.31c0,0,0.001-0.412-0.05-0.682l-0.346-0.399 l-0.155-0.019L11.29,8.154L11.239,8.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.388,9.398l0.431,1.405 c0,0,0.039,0.321-0.253,0.341H9.105"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M8.865,11.998c0,0,0.622,0.252,1.01-0.036"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 5.084,
    y1: 25.562,
    x2: 5.48,
    y2: 19.039
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 13.402,
    y1: 25.562,
    x2: 13.005,
    y2: 19.039
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M9.368,5.584c3.56,0.021,2.741,3.94,2.393,4.034c0,0-0.689-1.983-1.536-1.958 C9.448,9.955,7.36,8.621,6.804,9.557C6.381,9.335,5.909,5.564,9.368,5.584z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.519,26.484l-0.153-0.359 c-0.45,0.183-0.997,0.14-1.399-0.119c0.008,0.16,0.014,0.32,0.019,0.478C11.986,26.484,13.519,26.484,13.519,26.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.413,26.484 c0.003-0.152,0.006-0.304,0.012-0.458c-0.398,0.265-0.944,0.314-1.397,0.137l-0.132,0.321 C19.896,26.484,21.413,26.484,21.413,26.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.889,26.484 c-0.442-5.108-1.201-5.723-1.201-5.723c-1.034-0.802-3.29-1.105-3.925-1.177v-0.008c-0.011,0.001-0.025,0.003-0.038,0.004 c-0.013-0.001-0.027-0.003-0.038-0.004v0.008c-0.635,0.071-2.89,0.375-3.924,1.177c0,0-0.759,0.615-1.201,5.723H21.889z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.756,18.319 c0.128,0.027,0.258,0.041,0.39,0.039c0.558-0.01,1.08-0.09,1.588-0.259c0.051,0.76,0.146,1.623,0.322,1.975 c0.344,0.689-1.573,0.647-1.573,0.647s-1.649-0.047-1.203-0.699C15.683,19.433,15.74,18.525,15.756,18.319z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#161B43"
    },
    d: "M17.268,18.99c-0.325,0.121-0.668,0.114-0.994,0.008c-0.225-0.073-0.394-0.226-0.55-0.337 c0.084-0.431,0.034-0.375,0.034-0.375l1.918-1.543c0,0,0,0.965,0.112,1.951C17.622,18.838,17.63,18.856,17.268,18.99z"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7D9C1",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.426,16.524 c-0.005-0.364,0.104-0.661,0.334-0.664c0.04-0.001,0.081,0.008,0.121,0.024c-0.008-0.102-0.014-0.175-0.016-0.206 c-0.001-0.012-0.001-0.024-0.001-0.036c0-0.002,0-0.006,0-0.009l0,0c0-0.007,0-0.014,0.001-0.022c0-0.003,0-0.006,0-0.009 c0-0.007,0.001-0.014,0.001-0.022c0-0.006,0.001-0.012,0.001-0.018c0-0.007,0.001-0.013,0.001-0.02 c0.001-0.008,0.001-0.017,0.002-0.025c0.001-0.007,0.001-0.014,0.002-0.021c0.001-0.01,0.002-0.021,0.003-0.032 c0.001-0.007,0.001-0.013,0.002-0.02c0.002-0.012,0.003-0.026,0.005-0.039c0.001-0.006,0.002-0.012,0.003-0.019 c0.002-0.014,0.005-0.03,0.007-0.045c0.001-0.006,0.002-0.012,0.003-0.018c0.003-0.016,0.006-0.033,0.009-0.05 c0.001-0.006,0.002-0.011,0.003-0.017c0.003-0.018,0.007-0.036,0.011-0.055c0.001-0.006,0.003-0.011,0.004-0.017 c0.004-0.019,0.009-0.039,0.014-0.059c0.001-0.005,0.003-0.011,0.004-0.017c0.005-0.02,0.011-0.041,0.017-0.062 c0.002-0.005,0.003-0.011,0.005-0.017c0.006-0.021,0.013-0.042,0.02-0.064c0.002-0.006,0.004-0.011,0.006-0.017 c0.007-0.022,0.015-0.044,0.024-0.066c0.002-0.005,0.004-0.011,0.006-0.017c0.009-0.022,0.018-0.045,0.027-0.067 c0.002-0.006,0.005-0.011,0.007-0.017c0.01-0.023,0.02-0.045,0.031-0.068c0.003-0.006,0.005-0.011,0.008-0.017 c0.011-0.022,0.023-0.045,0.035-0.067c0.003-0.006,0.006-0.012,0.009-0.017c0.012-0.022,0.025-0.044,0.038-0.066 c0.004-0.006,0.007-0.012,0.011-0.018c0.013-0.022,0.028-0.043,0.042-0.065c0.004-0.006,0.008-0.012,0.012-0.018 c0.015-0.021,0.031-0.042,0.047-0.063c0.005-0.006,0.009-0.012,0.014-0.018c0.016-0.02,0.033-0.04,0.05-0.06 c0.005-0.006,0.011-0.013,0.016-0.019c0.017-0.019,0.036-0.038,0.054-0.057c0.006-0.006,0.012-0.013,0.019-0.019 c0.019-0.018,0.038-0.036,0.058-0.053c0.007-0.006,0.014-0.013,0.021-0.019c0.02-0.017,0.041-0.033,0.062-0.05 c0.008-0.006,0.016-0.013,0.024-0.019c0.021-0.016,0.044-0.031,0.067-0.045c0.009-0.006,0.018-0.012,0.027-0.019 c0.023-0.014,0.047-0.028,0.071-0.041c0.01-0.006,0.021-0.012,0.031-0.018c0.024-0.013,0.049-0.024,0.075-0.036 c0.012-0.006,0.023-0.012,0.035-0.017c0.025-0.011,0.052-0.021,0.079-0.032c0.013-0.005,0.025-0.011,0.039-0.015 c0.026-0.009,0.054-0.018,0.082-0.026c0.015-0.004,0.029-0.01,0.044-0.014c0.028-0.008,0.058-0.014,0.087-0.021 c0.016-0.004,0.031-0.008,0.048-0.011c0.03-0.006,0.062-0.011,0.093-0.016c0.017-0.003,0.033-0.006,0.051-0.009 c0.033-0.005,0.068-0.008,0.103-0.011c0.017-0.002,0.033-0.004,0.05-0.005c0.053-0.004,0.107-0.006,0.163-0.007 c0.054-0.001,0.106,0,0.157,0.003c0.017,0.001,0.033,0.002,0.049,0.003c0.034,0.002,0.067,0.004,0.1,0.008 c0.019,0.002,0.037,0.005,0.055,0.007c0.029,0.004,0.058,0.008,0.085,0.012c0.019,0.003,0.037,0.007,0.055,0.011 c0.026,0.005,0.052,0.01,0.078,0.017c0.018,0.004,0.035,0.009,0.052,0.014c0.024,0.007,0.049,0.014,0.072,0.021 c0.017,0.005,0.033,0.011,0.049,0.016c0.023,0.008,0.046,0.016,0.068,0.025c0.015,0.006,0.03,0.012,0.045,0.018 c0.022,0.01,0.044,0.019,0.066,0.03c0.013,0.006,0.027,0.013,0.04,0.019c0.022,0.011,0.043,0.023,0.064,0.035 c0.011,0.007,0.023,0.013,0.034,0.019c0.023,0.014,0.044,0.028,0.066,0.042c0.008,0.006,0.017,0.011,0.026,0.017 c0.026,0.018,0.052,0.038,0.076,0.057c0.003,0.002,0.006,0.004,0.009,0.007c0.056,0.045,0.107,0.093,0.154,0.142 c0.004,0.005,0.009,0.01,0.013,0.014c0.018,0.02,0.036,0.04,0.053,0.06c0.006,0.007,0.011,0.014,0.017,0.021 c0.015,0.019,0.03,0.037,0.044,0.056c0.006,0.008,0.011,0.016,0.017,0.024c0.013,0.018,0.026,0.037,0.038,0.055 c0.006,0.009,0.011,0.017,0.016,0.025c0.012,0.018,0.023,0.037,0.034,0.055c0.005,0.009,0.01,0.017,0.015,0.026 c0.011,0.019,0.021,0.037,0.031,0.056c0.004,0.008,0.009,0.017,0.013,0.025c0.01,0.019,0.019,0.038,0.028,0.057 c0.004,0.008,0.007,0.016,0.011,0.023c0.009,0.02,0.018,0.04,0.027,0.061c0.003,0.006,0.006,0.013,0.008,0.019 c0.009,0.022,0.018,0.045,0.026,0.067c0.001,0.004,0.003,0.008,0.005,0.012c0.02,0.053,0.036,0.105,0.051,0.156 c0,0.001,0.001,0.002,0.001,0.004c0.007,0.023,0.013,0.046,0.019,0.068c0.002,0.007,0.003,0.013,0.005,0.02 c0.004,0.017,0.008,0.033,0.012,0.049c0.002,0.009,0.004,0.017,0.005,0.025c0.003,0.013,0.006,0.027,0.008,0.04 c0.002,0.009,0.003,0.018,0.005,0.027c0.002,0.011,0.004,0.023,0.006,0.033s0.003,0.019,0.005,0.028 c0.002,0.009,0.003,0.018,0.004,0.027c0.002,0.01,0.003,0.019,0.004,0.029c0.001,0.007,0.002,0.014,0.003,0.02 c0.001,0.01,0.003,0.02,0.004,0.029c0,0.005,0.001,0.009,0.001,0.014c0.001,0.011,0.002,0.021,0.003,0.03c0,0,0,0,0,0.001l0,0 c0.003,0.037,0.005,0.066,0.006,0.083c0.001,0.012,0.001,0.024,0,0.037c-0.001,0.031-0.005,0.104-0.01,0.206 c0.04-0.017,0.08-0.027,0.12-0.028c0.23-0.003,0.346,0.291,0.351,0.655c0.004,0.345-0.341,0.633-0.572,0.664 c-0.039,0.343-0.097,0.637-0.148,0.761c-0.223,0.543-1.048,0.974-1.596,0.982c-0.548,0.007-1.211-0.276-1.65-0.939 c-0.074-0.111-0.12-0.415-0.168-0.757C14.783,17.147,14.431,16.869,14.426,16.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M15.345,15.198c0,0-0.108,0.554-0.084,1.444l-0.415-0.737c0,0-0.078-0.424,0.024-0.509l0.25-0.304 l0.115-0.017l0.07,0.022L15.345,15.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.235,15.074c0,0,0.152,0.64,0.128,1.509l0.389-0.815c0,0,0.001-0.307-0.038-0.508l-0.258-0.297 l-0.116-0.014l-0.069,0.024L18.235,15.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M16.857,15.899l0.321,1.046 c0,0,0.029,0.239-0.188,0.254h-0.344"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M16.468,17.835c0,0,0.463,0.188,0.752-0.027"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M13.743,26.386 c0.04-1.104,0.129-2.206,0.204-3.308"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.757,26.386 c-0.022-1.105-0.192-2.202-0.207-3.308"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M16.746,13.059c-2.651,0.016-2.041,2.934-1.782,3.004c0,0,0.964-1.092,1.144-1.458 c1.947,0.219,2.133,0.715,2.547,1.412C18.971,15.852,19.322,13.044,16.746,13.059z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 16.503,
    cy: 8.947,
    r: 3.421
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "18.819,7.971 17.464,7.971 17.464,6.616 15.603,6.616 15.603,7.971 14.248,7.971  14.248,9.833 15.603,9.833 15.603,11.188 17.464,11.188 17.464,9.833 18.819,9.833  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyMedicine);
export default __webpack_public_path__ + "static/media/family_medicine.1be907c589f7a18cc1fc7dcb27f1f23d.svg";
export { ForwardRef as ReactComponent };